import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  viewReferral,
  updateReferralStatus,
} from "../../Redux/Actions/referralsAction";
import { ToFirstCapital } from "../../Utils/helpers";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { icons } from "../../icons";

const ViewReferral = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const referralState = useSelector((state) => state.referrals || {});

  const [status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewReferral({ _id: id }));
    else console.warn("No referral ID found in URL");
  }, [dispatch, id]);

  useEffect(() => {
    if (referralState.referralDetails?.status) {
      setStatus(referralState.referralDetails.status);
    }
  }, [referralState.referralDetails]);

  const data = referralState.referralDetails || {};
  console.log("That is my data", data);
  console.log("Redux referral state:", referralState);
  console.log("Referral Details Data:", data);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = () => {
    setIsUpdating(true);
    setShowConfirm(false);
    dispatch(updateReferralStatus(data._id, selectedStatus)).finally(() =>
      setIsUpdating(false)
    );
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
      }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "2/8" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div
        className="back-icon margin-0 gap-10 align-center flex-container"
        style={{ gridColumn: "span 7" }}
      >
        <Link to="/referrals">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div className="referral-view">
          <h3>Referral Details</h3>
          <h4 style={{ position: "relative", top: "-10px", fontSize: "14px" }}>
            Referral / List / View
          </h4>
        </div>
      </div>

      <div
        className="overall-container"
        style={{ opacity: isUpdating ? 0.6 : 1 }}
      >
        <div
          style={{ backgroundColor: "rgba(255, 255, 255, 0.16)" }}
          className="flex-container flex-justify-between border-24 align-center padding-20"
        >
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Booking ID
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {data.booking?.booking_id || "No Data"}
              </h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Booking Date
              </span>
              <h2 className="h2-column">
                {data.booking?.created_at
                  ? new Date(data.booking.created_at).toLocaleString()
                  : "No Data"}
              </h2>
            </div>
          </div>
          <hr className="project_hr" />

          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Referral Amount
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {data.referral_amount || "No Data"}
              </h2>
            </div>
            <div
              className="flex-container flex-column"
              style={{ marginTop: "10px" }}
            >
              <span className="span-column" style={{ color: "#999" }}>
                Referral From User Name
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {data.referral_from_user?.name || "No Data"}
              </h2>
            </div>
          </div>

          <hr className="project_hr" />
        </div>

        <div className="flex-container flex-justify-around margin-h-10 margin-top-20">
          <div className="column1" style={{ flex: "1" }}>
            <div
              className="flex-container gap-10 padding-10"
              style={{ alignItems: "start" }}
            >
              <img src={icons["Name"]} alt="" />
              <div>
                <span className="span_project" style={{ color: "#999" }}>
                  From User Name
                </span>
                <h4 className="div-h4">
                  {data.referral_from_user?.name || "No Data"}
                </h4>
                <span className="span_project" style={{ color: "#999" }}>
                  Email
                </span>
                <h4 className="div-h4">
                  {data.referral_from_user?.email || "No Data"}
                </h4>
                <span className="span_project" style={{ color: "#999" }}>
                  Contact
                </span>
                <h4 className="div-h4">
                  {data.referral_from_user?.country_code}{" "}
                  {data.referral_from_user?.contact_number || "No Data"}
                </h4>
              </div>
            </div>
          </div>
          <hr className="project_hr" />
          <div className="column2" style={{ flex: "1" }}>
            <div
              className="flex-container gap-10 padding-10"
              style={{ alignItems: "start" }}
            >
              <img src={icons["Name"]} alt="" />
              <div>
                <span className="span_project" style={{ color: "#999" }}>
                  To User Name
                </span>
                <h4 className="div-h4">
                  {data.referral_to_user?.name || "No Data"}
                </h4>
                <span className="span_project" style={{ color: "#999" }}>
                  Email
                </span>
                <h4 className="div-h4">
                  {data.referral_to_user?.email || "No Data"}
                </h4>
                <span className="span_project" style={{ color: "#999" }}>
                  Contact
                </span>
                <h4 className="div-h4">
                  {data.referral_to_user?.country_code}{" "}
                  {data.referral_to_user?.contact_number || "No Data"}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="column7" style={{ flex: "1", marginTop: "30px" }}>
          <div
            className="flex-container flex-column gap-10 padding-10"
            style={{ alignItems: "start" }}
          >
            <span className="span_project" style={{ color: "#999" }}>
              Referral Status
            </span>
            <select
              value={status}
              onChange={handleStatusChange}
              className="div-h4"
              disabled={isUpdating}
              style={{
                width: "15%",
                padding: "8px",
                borderRadius: "8px",
                backgroundColor: "white",
                color: "black",
                border: "1px solid #ccc",
                marginTop: "5px",
                cursor: isUpdating ? "not-allowed" : "pointer",
              }}
            >
              <option value="" disabled>
                Select Status
              </option>
              {["paid", "closed", "cancelled", "ongoing"].map((stat) => (
                <option key={stat} value={stat}>
                  {ToFirstCapital(stat)}
                </option>
              ))}
            </select>
            {isUpdating && (
              <p style={{ color: "white", marginTop: "5px" }}>
                Updating status...
              </p>
            )}
          </div>
        </div>

        {showConfirm && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "12px",
                minWidth: "300px",
                textAlign: "center",
              }}
            >
              <p>
                Are you sure you want to change status to "
                {ToFirstCapital(selectedStatus)}"?
              </p>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <button
                  onClick={confirmStatusChange}
                  disabled={isUpdating}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: isUpdating ? "not-allowed" : "pointer",
                    backgroundColor: "green",
                    color: "white",
                  }}
                >
                  Yes
                </button>
                <button
                  onClick={() => setShowConfirm(false)}
                  disabled={isUpdating}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: isUpdating ? "not-allowed" : "pointer",
                    backgroundColor: "red",
                    color: "white",
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewReferral;
